import { Avatar, Box, Button, Typography } from "@mui/material";
import { PropTypes } from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { identifiersData } from "@/data";
import { theme } from "@/theme";

const Blank = ({ buttonName, buttonText, description, onClickButton, title, withoutButton }) => {
    const [showLogo, setShowLogo] = useState(true);

    const { t } = useTranslation();

    return (
        <Box>
            {showLogo && import.meta.env.VITE_SHOW_CMS_LOGO === "true" ? (
                <Avatar
                    alt={t("imageAlternatives.logo")}
                    src={import.meta.env.VITE_CMS_MINI_LOGO}
                    slotProps={{
                        img: {
                            loading: "lazy",
                            onError: () => setShowLogo(false),
                        },
                    }}
                />
            ) : (
                <Typography color={theme.palette.primary.main} sx={{ fontSize: 30 }} variant="caption">
                    {import.meta.env.VITE_CMS_LOGO_NAME}
                </Typography>
            )}
            <Typography
                component="h1"
                variant="h4"
                sx={{
                    mb: 2,
                    mt: 2,
                    textAlign: "center",
                }}
            >
                {title}
            </Typography>
            {description && (
                <Typography
                    variant="body1"
                    sx={{
                        mb: 2,
                        textAlign: "center",
                    }}
                >
                    {description}
                </Typography>
            )}
            {!withoutButton && (
                <Button id={`${buttonName}_${identifiersData.ids.button}`} variant="contained" onClick={onClickButton}>
                    {buttonText}
                </Button>
            )}
        </Box>
    );
};

export default Blank;

Blank.propTypes = {
    buttonName: PropTypes.string,
    buttonText: PropTypes.string,
    description: PropTypes.string,
    onClickButton: PropTypes.func,
    title: PropTypes.string,
    withoutButton: PropTypes.bool,
};
